import produce from 'immer';
import { types, IRouteAlias, IRouteAliasesResponse } from './types';

export interface IRouteAliasInitialState {
    routeAlias: IRouteAlias | undefined;
    gettingRouteAlias: boolean;
    gettingRouteAliasError: null | any;

    routeAliases: IRouteAliasesResponse | undefined;
    gettingAllRouteAliases: boolean;
    gettingAllRouteAliasesError: null | any;

    creatingRouteAlias: boolean;
    creatingRouteAliasError: null | any;

    updatingRouteAlias: boolean;
    updatingRouteAliasError: null | any;

    deletingRouteAlias: boolean;
    deletingRouteAliasError: null | any;
}

const initialState: IRouteAliasInitialState = {
    routeAlias: undefined,
    gettingRouteAlias: false,
    gettingRouteAliasError: null,

    routeAliases: undefined,
    gettingAllRouteAliases: false,
    gettingAllRouteAliasesError: null,

    creatingRouteAlias: false,
    creatingRouteAliasError: null,

    updatingRouteAlias: false,
    updatingRouteAliasError: null,

    deletingRouteAlias: false,
    deletingRouteAliasError: null,
};

const reducer = (state = initialState, action: any) => {
    const { type, payload } = action;

    switch (type) {
        case types.GET_ROUTE_ALIAS:
            return produce(state, draft => {
                draft.gettingRouteAlias = true;
                draft.gettingRouteAliasError = null;
            });
        case types.GET_ROUTE_ALIAS_SUCCESS:
            return produce(state, draft => {
                draft.routeAlias = payload;
                draft.gettingRouteAlias = false;
            });
        case types.GET_ROUTE_ALIAS_FAIL:
            return produce(state, draft => {
                draft.gettingRouteAlias = false;
                draft.gettingRouteAliasError = payload;
            });

        case types.GET_ALL_ROUTE_ALIASES:
            return produce(state, draft => {
                draft.gettingAllRouteAliases = true;
                draft.gettingAllRouteAliasesError = null;
            });
        case types.GET_ALL_ROUTE_ALIASES_SUCCESS:
            return produce(state, draft => {
                draft.routeAliases = payload;
                draft.gettingAllRouteAliases = false;
            });
        case types.GET_ALL_ROUTE_ALIASES_FAIL:
            return produce(state, draft => {
                draft.gettingAllRouteAliases = false;
                draft.gettingAllRouteAliasesError = payload;
            });

        case types.CREATE_ROUTE_ALIAS:
            return produce(state, draft => {
                draft.creatingRouteAlias = true;
                draft.creatingRouteAliasError = null;
            });
        case types.CREATE_ROUTE_ALIAS_SUCCESS:
            return produce(state, draft => {
                draft.creatingRouteAlias = false;
                // Refresh the list by setting routeAliases to undefined to trigger refetch
                if (draft.routeAliases) {
                    draft.routeAliases = undefined;
                }
            });
        case types.CREATE_ROUTE_ALIAS_FAIL:
            return produce(state, draft => {
                draft.creatingRouteAlias = false;
                draft.creatingRouteAliasError = payload;
            });

        case types.UPDATE_ROUTE_ALIAS:
            return produce(state, draft => {
                draft.updatingRouteAlias = true;
                draft.updatingRouteAliasError = null;
            });
        case types.UPDATE_ROUTE_ALIAS_SUCCESS:
            return produce(state, draft => {
                draft.updatingRouteAlias = false;
                // Update the item in the list if it exists
                if (draft.routeAliases?.data?.data) {
                    const index = draft.routeAliases.data.data.findIndex(item => item._id === payload._id);
                    if (index !== -1) {
                        draft.routeAliases.data.data[index] = payload;
                    }
                }
            });
        case types.UPDATE_ROUTE_ALIAS_FAIL:
            return produce(state, draft => {
                draft.updatingRouteAlias = false;
                draft.updatingRouteAliasError = payload;
            });

        case types.DELETE_ROUTE_ALIAS:
            return produce(state, draft => {
                draft.deletingRouteAlias = true;
                draft.deletingRouteAliasError = null;
            });
        case types.DELETE_ROUTE_ALIAS_SUCCESS:
            return produce(state, draft => {
                draft.deletingRouteAlias = false;
                // Remove the item from the list if it exists
                if (draft.routeAliases?.data?.data) {
                    draft.routeAliases.data.data = draft.routeAliases.data.data.filter(item => item._id !== payload);
                    draft.routeAliases.totalCount = Math.max(0, draft.routeAliases.totalCount - 1);
                    draft.routeAliases.results = Math.max(0, draft.routeAliases.results - 1);
                }
            });
        case types.DELETE_ROUTE_ALIAS_FAIL:
            return produce(state, draft => {
                draft.deletingRouteAlias = false;
                draft.deletingRouteAliasError = payload;
            });

        default:
            return state;
    }
};

export { reducer };
